import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { truncateText, formatDate, getData, apiUrl } from "../util";
import QueueItem from "../components/QueueItem";
import QueueNav from "../components/QueueNav";
import QueueCompanyFilter from "../components/QueueCompanyFilter";
import TagSearch from "../components/TagSearch";
import request from "request";
class ProblemQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      platform: "all",
      items: [],
      tlds: [],
      allItems: [],
      company: null,
      important: false,
      customers: [],
    };
  }
  componentDidMount() {
    this.getData();
    return;
  }
  getData = () => {
    const { company, important } = this.state;

    let qs = "";
    if (company) {
      qs = `?company=${company}`;
      if (important) {
        qs = `${qs}&important=true`;
      }
    } else if (important) {
      qs = `?important=true`;
    }
    request(
      {
        url: `${apiUrl}/v1/admin/v2/queue/problem${qs}`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        json.companies.sort((a, b) => {
          if (!a.name) {
            return -1;
          }
          if (!b.name) {
            return 1;
          }
          return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
        });
        this.setState({
          items: this.refilterData(json.items),
          allItems: json.items,
          customers: json.customers,
          companies: json.companies.map(c => ({
            value: c.tld,
            label: `${c.name} (${c.tld})`,
          })),
        });
      }
    );
  };
  remove = id => {
    this.setState({
      items: [],
    });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  refilterData = items => {
    const { important, tlds, country, platform } = this.state;

    let retData = items;

    if (important === "landing") {
      retData = items.filter(i => i.landingPage);
    }
    if (country) {
      if (country === "us") {
        retData = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        retData = items.filter(i => {
          if (i.url.endsWith(`#${country}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (platform !== "all") {
      retData = items.filter(q => q.platform === platform);
    }
    if (tlds && tlds.length > 0) {
      retData = items.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    return retData.slice(0, 4000);
  };
  filterByCompany = (company, important, country, tldsi, platform) => {
    let items = this.state.allItems;
    let landingPagesOnly = this.state.landingPagesOnly;
    let tlds = tldsi ? tldsi : this.state.tlds;
    let plat = platform ? platform : this.state.platform;
    let cntry = country ? country : this.state.country;

    if (company && this.state.company !== company) {
      this.setState(
        {
          company,
        },
        this.getData
      );
      return;
    }
    if (important) {
      if (important === "landing") {
        items = items.filter(i => i.landingPage);
        landingPagesOnly = true;
      } else if (important !== this.state.important) {
        this.setState(
          {
            important: important === "true" ? true : false,
            landingPagesOnly: false,
          },
          this.getData
        );
        return;
      }
    }
    if (cntry) {
      if (cntry === "us") {
        items = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        items = items.filter(i => {
          if (i.url.endsWith(`#${cntry}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (tlds && tlds.length > 0) {
      items = items.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (plat && plat !== "all") {
      items = items.filter(q => q.platform === plat);
    }
    this.setState({
      items: items.slice(0, 400),
      landingPagesOnly,
      tlds: tlds ? tlds : this.state.tlds,
      platform: platform ? platform : this.state.platform,
      country: country ? country : this.state.country,
    });
  };
  doTldFilter = tlds => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      tlds
    );
  };
  render() {
    const { user } = this.props;
    const { items, customers } = this.state;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }
    return (
      <div>
        <h1>Problem Queue</h1>
        <QueueNav selected="problem" />
        <QueueCompanyFilter
          selected={this.state.company}
          handleClick={this.filterByCompany}
          companies={customers}
        />
        <div className="w-50">
          <TagSearch
            options={this.state.companies}
            callback={this.doTldFilter}
            placeholder="Filter by company"
          />
        </div>
        {items &&
          items.map(item => (
            <QueueItem
              item={item}
              remove={this.remove}
              qType="problem"
              id={item.id}
              user={this.props.user}
              callback={this.getData}
            />
          ))}
      </div>
    );
  }
}

export default ProblemQueue;
